import {
  UI_MANAGED_CONTENT_ENDPOINT,
  REGISTRATION_VARIANTS_FILE_BASE_PATH,
  PREVIEW_REGISTRATION_VARIANTS_PARAM,
} from '../constants';
import { RegistrationVariantProps } from '../interfaces/registrationVariant';

const getRegistrationVariantsJsonFilePath = () => {
  const shouldLoadPreview =
    new URLSearchParams(window.location.search).get(PREVIEW_REGISTRATION_VARIANTS_PARAM) === 'true';

  const jsonFilePath = `${REGISTRATION_VARIANTS_FILE_BASE_PATH}/${
    shouldLoadPreview ? 'stage2.json' : 'production.json'
  }`;

  return jsonFilePath;
};

export const fetchRegistrationVariants = async (): Promise<RegistrationVariantProps[]> => {
  try {
    const response = await fetch(`${UI_MANAGED_CONTENT_ENDPOINT}${getRegistrationVariantsJsonFilePath()}`);

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Failed to fetch registration variants: ${error}`);
  }
};
